<a aria-label="button">
  <rx-icon name="edit" fill="text-color" />
</a>
